import { breakComma, formatDateKanji } from '@/util/common'

export const ContractFreeTrialRequestConfirm = (props, context) => {
  const store = context.root.$store
  const { trial: { data } } = store.state

  const close = () => {
    context.emit('closeViewConfirm')
  }
  const openViewComplete = () => {
    context.emit('openViewComplete')
  }
  return {
    close,
    openViewComplete,
    data,
    formatDateKanji,
    breakComma
  }
}
